import React from "react";
import SmartOnlineLink from "./SmartOnlineLink";
import Store from "./../../../content/Store";
import Contentify from "../../../content/Contentify";

export const GeneralEnquiry = (props) => {
  let { linkText, pathTo, iconName, id } = props.content;
  if(props.featureFlagEP === true){
    pathTo=props.url;
  }
  return (
    <>
    {props.featureFlagEP === true ?
      <SmartOnlineLink linkText={linkText} pathTo={pathTo} iconName={iconName} isExternalLink={true}
        isDisabled={props.isDisabled}
        disableStyle={props.disableStyle} id={id}/>:
    <SmartOnlineLink linkText={linkText} pathTo={pathTo} iconName={iconName} isExternalLink={false} id={id}/>}
    </>
  );
};

GeneralEnquiry.content = Store.GeneralEnquirySmartLink;

export default Contentify(GeneralEnquiry);
